import { useScene } from 'providers/SceneProvider'
import { FC, useEffect } from 'react'
import { getSlides } from 'utils/getData'
import SlideItem from './SlideItem'

interface Props {
  map: google.maps.Map
}

const Slides: FC<Props> = ({ map }) => {
  const { selectedSlide } = useScene()
  const width = window.innerWidth
  const zoomOutTerm = width > 1000 ? 0.0 : 1.0
  useEffect(() => {
    map.setCenter(selectedSlide.cameraParameters.targetPosition)
    map.setZoom(selectedSlide.cameraParameters.zoom - zoomOutTerm)
    map.setTilt(selectedSlide.cameraParameters.tilt)
    map.setHeading(selectedSlide.cameraParameters.heading)
  }, [selectedSlide, map, zoomOutTerm])

  return (
    <>
      {/* {selectedSlide.id === 'slide-2' && (
        <>
          <LocationInformation position={new Vector3(160, -131, 0)} rotationZ={-0.3} />
          <LocationInformation position={new Vector3(265, -110, 0)} rotationZ={-0.3} color={'#595'} />
        </>
      )} */}
      {getSlides()
        .filter((slide) => slide.model)
        .map((slide, index) => (
          <SlideItem key={index} slide={slide} />
        ))}
    </>
  )
}

export default Slides
